/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ApolloError, gql, useMutation } from "@apollo/client";

import { useErrorsOrSuccessHandler } from "graphql/errorHandlers";
import {
  ACCOUNT_FRAGMENT,
  AccountFragment,
  ERROR_FRAGMENT,
  ErrorFragment,
} from "graphql/fragments";
import { CancelAccountDeletionInput } from "graphql/types";

const CANCEL_ACCOUNT_DELETION = gql`
  mutation ($input: CancelAccountDeletionInput!) {
    cancelAccountDeletion(input: $input) {
      account {
        ...AccountFragment
      }
      errors {
        ...ErrorFragment
      }
    }
  }
  ${ACCOUNT_FRAGMENT}
  ${ERROR_FRAGMENT}
`;

interface Payload {
  account?: AccountFragment | null;
  errors: ErrorFragment[];
}

interface CancelAccountDeletionMutation {
  cancelAccountDeletion: Payload | null;
}

export const useCancelAccountDeletionMutation = () => {
  const handleErrors = useErrorsOrSuccessHandler();

  const [mutation, { data, loading }] = useMutation<
    CancelAccountDeletionMutation,
    { input: CancelAccountDeletionInput }
  >(CANCEL_ACCOUNT_DELETION);

  const cancelAccountDeletion = (
    input: CancelAccountDeletionInput = {},
    onSuccess?: (account: AccountFragment) => void
  ) =>
    mutation({ variables: { input } })
      .then(({ data, errors }) => {
        const dataErrors = data?.cancelAccountDeletion?.errors ?? [];
        const account = data?.cancelAccountDeletion?.account;

        handleErrors({
          dataErrors,
          graphqlErrors: errors,
          onSuccess: () => onSuccess && account && onSuccess(account),
        });
      })
      .catch((_error: ApolloError) => null);

  return {
    cancelAccountDeletion,
    isLoading: loading,
    account: data?.cancelAccountDeletion?.account,
    errors: data?.cancelAccountDeletion?.errors ?? [],
  };
};
